import React from 'react'

const Ppt = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/ppt',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <defs>
      <path id='a' d='M0 0h6.364v10H0z' />
    </defs>
    <g
      fill='none'
      fillRule='evenodd'
      transform='translate(1 1)'
    >
      <rect
        fill={primaryColor}
        height='90%'
        rx={2}
        width='90%'
      />
      <g transform='translate(6 4)'>
        <mask id='b' fill={secondaryColor}>
          <use xlinkHref='#a' />
        </mask>
        <path
          d='M1.88 10H0V.012c1.451 0 2.894-.04 4.333.026.378.017.817.284 1.096.558 1.068 1.05 1.068 2.357.749 3.66-.285 1.161-1.072 1.978-2.313 2.266-.617.143-1.279.116-1.984.171V10zm.054-5.246c.749.055 1.48.188 1.935-.55.344-.558.315-1.577-.084-2.005-.515-.554-1.182-.475-1.851-.374v2.93z'
          mask='url(#b)'
          fill={secondaryColor} />
      </g>
    </g>
  </svg>
)

export default Ppt
